import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

// Add the icon to the library
library.add(faExclamationTriangle);

const NotFound = () => {
  return (
    <div className="not-found">
      <FontAwesomeIcon icon="exclamation-triangle" className="not-found-icon" />
      <h1 className="not-found-title">404</h1>
      <p className="not-found-message">Oops! The page you're looking for does not exist.</p>
      <button className="back-home-button" onClick={() => window.location.href = '/'}>
        Go Back Home
      </button>
    </div>
  );
};

export default NotFound;
